import { Component } from "react"
import PropTypes from "prop-types"
import "./empty_state_component.scss"

export default class EmptyStateComponent extends Component {
  render() {
    return (
      <>
        <h1 styleName="empty-state-header">Start connecting your world.</h1>
        <img
          styleName="empty-state-hero-img"
          src={this.props.heroImages[0]}
          srcSet={`${this.props.heroImages[0]}, ${this.props.heroImages[1]} 2x, ${this.props.heroImages[2]} 3x`}
          alt="Get started using IFTTT"
          width="600"
          height="600"
        />
        <a
          styleName="get-more-button"
          className="button-primary"
          style={{ backgroundColor: `${this.props.buttonColor}` }}
          role="button"
          href={this.props.buttonLink}
        >
          Get more
        </a>
      </>
    )
  }
}

EmptyStateComponent.propTypes = {
  buttonColor: PropTypes.string.isRequired,
  buttonLink: PropTypes.string,
  heroImages: PropTypes.array,
}

EmptyStateComponent.defaultProps = {
  buttonLink: "/get_more",
}
